
import React, { useState } from "react";
import {
  FiInstagram,
  FiFacebook,
  FiYoutube,
  FiArrowRight,
} from "react-icons/fi";
import { FaXTwitter, FaPinterestP } from "react-icons/fa6";

const footerGroups = [
  {
    title: "Shop",
    links: [
      { label: "All Categories", href: "/categories" },
      { label: "New Arrivals", href: "/new-arrivals" },
      { label: "Best Sellers", href: "/best-sellers" },
      { label: "Deals", href: "/deals" },
      { label: "Brands", href: "/brands" },
    ],
  },
  {
    title: "Customer Care",
    links: [
      { label: "Help Center", href: "/help-center" },
      { label: "Shipping Info", href: "/shipping" },
      { label: "Returns", href: "/returns" },
      { label: "Track Your Order", href: "/track-order" },
      { label: "Contact Us", href: "/contact" },
    ],
  },
  {
    title: "Sell With Us",
    links: [
      { label: "Become a Seller", href: "/sell" },
      { label: "Vendor Resources", href: "/vendor-resources" },
      { label: "Our Marketplace", href: "/marketplace" },
      { label: "Success Stories", href: "/success-stories" },
    ],
  },
  {
    title: "About Pufframa",
    links: [
      { label: "Our Story", href: "/about" },
      { label: "Blog", href: "/blog" },
      { label: "Careers", href: "/careers" },
      { label: "Press", href: "/press" },
      { label: "Affiliate Program", href: "/affiliate" },
    ],
  },
];

const legalLinks = [
  { label: "Privacy Policy", href: "/privacy-policy" },
  { label: "Terms of Service", href: "/terms-of-service" },
  { label: "Age Verification", href: "/age-verification" },
  { label: "Cookie Preferences", href: "/cookie-preferences" },
];

export default function Footer() {
  const [email, setEmail] = useState("");

  const handleSubscribe = (e) => {
    e.preventDefault();

    if (!email.trim()) return;

    // Connect your newsletter API here.
    // This form is ready for your subscription endpoint.
  };

  return (
    <footer className="w-full border-t border-[#e9e5e9] bg-white font-sans text-[#27232b]">
      <div className="mx-auto max-w-[1500px] px-5 sm:px-7 lg:px-[4%]">

        {/* Main footer */}
        <div className="grid grid-cols-2 gap-x-6 gap-y-8 py-8 sm:grid-cols-3 lg:grid-cols-[1.5fr_0.8fr_1fr_0.9fr_0.9fr_1.3fr] lg:gap-x-6 lg:gap-y-0 lg:py-6">

          {/* Brand */}
        <div className="col-span-2 min-w-0 sm:col-span-3 lg:col-span-1">
  <a href="/" className="inline-flex flex-col no-underline">
    <span className="text-[27px] font-black leading-[27px] tracking-[-1.3px] text-[#17151b]">
      PUFF<span className="text-[#17151b]">RAMA</span>
    </span>

    <span className="mt-1 whitespace-nowrap text-[10px] font-bold  leading-3 tracking-[2.5px] text-[#49424f]">
     No Business Drama
    </span>
  </a>


</div>

          {/* Footer link groups */}
          {footerGroups.map((group) => (
            <div key={group.title} className="min-w-0">
              <h3 className="mb-3 text-[14px] font-bold leading-5 text-[#24202a] lg:text-[13px]">
                {group.title}
              </h3>

              <ul className="m-0 list-none space-y-[7px] p-0">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      className="text-[12px] leading-[18px] text-[#6f6977] no-underline transition-colors hover:text-[#7027df] lg:text-[11px] lg:leading-[17px]"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          {/* Newsletter */}
          <div className="col-span-2 min-w-0 sm:col-span-3 lg:col-span-1">
            <h3 className="text-[14px] font-bold leading-5 text-[#24202a] lg:text-[13px]">
              Join Our Community
            </h3>

            <p className="mt-1 text-[12px] leading-[18px] text-[#6f6977] lg:text-[11px]">
              Get exclusive deals, new arrivals and more.
            </p>

            <form
              onSubmit={handleSubscribe}
              className="mt-3 flex h-[36px] w-full max-w-[280px] items-stretch overflow-hidden rounded-[5px] border border-[#e2dce8] bg-white lg:h-[34px]"
            >
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email"
                required
                aria-label="Email address"
                className="min-w-0 flex-1 border-0 bg-transparent px-3 text-[12px] text-[#27232b] outline-none placeholder:text-[#918a98] focus:ring-0"
              />

              <button
                type="submit"
                aria-label="Subscribe to newsletter"
                className="flex w-[38px] shrink-0 items-center justify-center bg-[#7027df] text-white transition-colors hover:bg-[#511caf]"
              >
                <FiArrowRight size={17} />
              </button>
            </form>

            {/* Social icons */}
            <div className="mt-4 flex items-center gap-4 text-[#302b34]">
              <a
                href="#"
                aria-label="Instagram"
                className="transition-colors hover:text-[#7027df]"
              >
                <FiInstagram size={17} />
              </a>

              <a
                href="#"
                aria-label="Facebook"
                className="transition-colors hover:text-[#7027df]"
              >
                <FiFacebook size={17} />
              </a>

              <a
                href="#"
                aria-label="X"
                className="transition-colors hover:text-[#7027df]"
              >
                <FaXTwitter size={15} />
              </a>

              <a
                href="#"
                aria-label="YouTube"
                className="transition-colors hover:text-[#7027df]"
              >
                <FiYoutube size={18} />
              </a>

              <a
                href="#"
                aria-label="Pinterest"
                className="transition-colors hover:text-[#7027df]"
              >
                <FaPinterestP size={16} />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="flex flex-col gap-3 border-t border-[#ece8ed] py-4 sm:flex-row sm:items-center sm:justify-between sm:gap-5">
          <p className="m-0 text-[11px] leading-[17px] text-[#716b77]">
            © 2024 Pufframa. All rights reserved.
          </p>

          <div className="flex flex-wrap items-center gap-x-5 gap-y-3">
            {legalLinks.map((link) => (
              <a
                key={link.label}
                href={link.href}
                className="text-[11px] leading-[17px] text-[#716b77] no-underline transition-colors hover:text-[#7027df]"
              >
                {link.label}
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
